import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { outputFromObservable, toObservable } from '@angular/core/rxjs-interop';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { debounce, distinctUntilChanged, skip, timer } from 'rxjs';
import {
  NgHeaderTemplateDirective,
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from '@ng-select/ng-select';
import { TranslocoDirective } from '@jsverse/transloco';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import { RemoteSelectOptionInterface } from '../../types';
import { provideUiKitScope } from '../../providers';
import { KeeniconComponent } from '../../partials';

@Component({
  selector: 'ui-form-remote-select',
  imports: [
    NgSelectComponent,
    ReactiveFormsModule,
    NgHeaderTemplateDirective,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    TranslocoDirective,
    ValidationFormComponent,
    KeeniconComponent,
  ],
  templateUrl: './form-remote-select.component.html',
  styleUrl: './form-remote-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormRemoteSelectComponent {
  dataCy = input<string>('');
  control = input.required<AbstractControl>();
  items = input<RemoteSelectOptionInterface[]>([]);
  isLoading = input<boolean>(false);
  hasMore = input<boolean>(false);
  placeholder = input<string>('');
  class = input<string>('');
  clearable = input<boolean>(true);
  disabled = input<boolean>(false);
  description = input<string>('');
  debounceTime = input<number>(500);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueChange = output<any>();
  scrollEnd = output<void>();
  searchTerm = signal('');

  search = outputFromObservable(
    toObservable(this.searchTerm).pipe(
      skip(1),
      debounce(() => timer(this.debounceTime())),
      distinctUntilChanged(),
    ),
  );

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  onScrollToEnd() {
    if (this.hasMore() && !this.isLoading()) {
      this.scrollEnd.emit();
    }
  }

  onChange(item: RemoteSelectOptionInterface | null) {
    this.valueChange.emit(item?.id ?? null);
  }

  onSearchInput(event: Event) {
    this.searchTerm.set((event.target as HTMLInputElement).value.trim());
  }
}
